import Vue from 'vue'
import Router from 'vue-router'
import UserHome from './views/UserHome.vue'
import ProjectStart from './views/ProjectStart.vue'
import Project from './views/Project.vue'
import Entry from './views/Entry.vue'
import Login from './views/Login.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'user_home',
      component: UserHome,
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/project/new',
      name: 'hora_project_new',
      component: Project
    },
    {
      path: '/project/:projectIdentifier/new',
      name: 'hora_project_start',
      component: ProjectStart
    },
    {
      path: '/entry/:entryId',
      name: 'hora_entry',
      component: Entry
    }
  ]
})
